document.addEventListener('DOMContentLoaded', function () {
  // Mobile navigation toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var links = document.querySelector('[data-nav-links]');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      links.classList.toggle('open');
    });
  }

  // Product page: thumbnail gallery — clicking a thumbnail swaps the main image
  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full-src');
        if (!full || mainImage.getAttribute('src') === full) return;
        mainImage.setAttribute('src', full);
        mainImage.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.toggle('on', t === thumb); });
      });
    });
  }

  // Product page: size-button variant picker
  var form = document.getElementById('product-form');
  if (form) {
    var select = form.querySelector('[data-variant-select]');
    var priceEl = document.querySelector('[data-price]');
    var skuEl = document.querySelector('[data-sku]');
    var addBtn = form.querySelector('[data-add-btn]');
    var buttons = form.querySelectorAll('[data-variant-button]');

    function syncFromSelect() {
      if (!select || !select.options.length) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      if (priceEl && opt.getAttribute('data-price')) {
        priceEl.textContent = opt.getAttribute('data-price');
      }
      if (skuEl && opt.getAttribute('data-sku')) {
        skuEl.textContent = opt.getAttribute('data-sku');
      }
      buttons.forEach(function (btn) {
        btn.classList.toggle('on', btn.getAttribute('data-variant-id') === select.value);
      });
      if (addBtn) {
        var available = opt.getAttribute('data-available') === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label') : 'Sold out';
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!select) return;
        select.value = btn.getAttribute('data-variant-id');
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (select) {
      select.addEventListener('change', syncFromSelect);
      syncFromSelect();
    }
  }
});
